import { StyleSheet } from 'react-native';

export const grayColor = '#89909B';
export const greenColor = '#0F6657';
export const darkColor = '#001639';
export const disabledColorForTabsTotem = '#979797';

export const globalStyles = StyleSheet.create({});
